import { render, staticRenderFns } from "./specDetail.vue?vue&type=template&id=64876283&scoped=true"
import script from "./specDetail.vue?vue&type=script&lang=js"
export * from "./specDetail.vue?vue&type=script&lang=js"
import style0 from "./specDetail.vue?vue&type=style&index=0&id=64876283&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64876283",
  null
  
)

export default component.exports